import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

const CONFIG = {
  auth: {
    clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
    authority: process.env.VUE_APP_MSAL_AUTHORITY,
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
  },
};
const SCOPES = ['api://2a7d29dd-9685-431f-aa8e-1ec2f9d0d3f5/AccessApi'];

const pca = new PublicClientApplication(CONFIG);
await pca.initialize();

const redirectResponse = await pca.handleRedirectPromise();
if (redirectResponse !== null) pca.setActiveAccount(redirectResponse.account);

export async function login(request) {
  return pca.loginRedirect(request);
}

export async function logout(request) {
  return pca.logoutRedirect(request);
}

export async function getAccessToken() {
  const request = { scopes: SCOPES };

  try {
    const response = await pca.acquireTokenSilent(request);
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      return pca.acquireTokenRedirect(request);
    }
    throw error;
  }
}

export function getActiveAccount() {
  return pca.getActiveAccount();
}
